jQuery(document).ready(function($) { 
  "use strict"; 

  let handleProduct = '';
  let viewingInterval = null;

  $(document).on('hidden.bs.modal', function () {
    $('body').removeClass('modal-open'); 
    $('.modal-backdrop').remove();
  });

  document.querySelector('.open-cart').addEventListener('click', function (e) {
    e.preventDefault();
    $('.tf-minicart-recommendations').removeClass('open');
    $('.notification-add-cart').hide();

    // let currentModal = bootstrap.Modal.getInstance(document.querySelector('.modal.show'));
    // if (currentModal) currentModal.hide();

    // const cartModal = new bootstrap.Modal(document.getElementById('shoppingCart'));
    // cartModal.show();
  });


  /**
   * @param {string} priceStr
   * @param {number} quantity 
   * @returns {string} 
   */
  function multiplyPriceWithQuantity(priceStr, quantity) {
    let amount = 0;
    let prefix = '';
    let suffix = '';

    if (typeof priceStr === 'number') {
      amount = priceStr;
    } else {
      const regex = /^([^\d\s.,]*)\s*([\d.,]+)\s*([^\d\s.,]*)$/;
      const match = String(priceStr).trim().match(regex);
      if (!match) return 'Invalid amount format';

      prefix = match[1];
      let rawNumber = match[2];
      suffix = match[3];

      const currency = (window.ShopCurrency || 'USD').toUpperCase();

      const zeroDecimalCurrencies = ['VND', 'JPY', 'KRW', 'IDR', 'THB'];
      if (zeroDecimalCurrencies.includes(currency)) {
        rawNumber = rawNumber.replace(/\./g, '').replace(/,/g, '');
      } else {
        const hasComma = rawNumber.includes(',');
        const hasDot = rawNumber.includes('.');

        if (hasComma && hasDot) {
          if (rawNumber.lastIndexOf(',') > rawNumber.lastIndexOf('.')) {
            rawNumber = rawNumber.replace(/\./g, '').replace(',', '.');
          } else {
            rawNumber = rawNumber.replace(/,/g, '');
          }
        } else if (hasComma && !hasDot) {
          rawNumber = rawNumber.replace(',', '.');
        } else {
          rawNumber = rawNumber.replace(/,/g, '');
        }
      }

      amount = parseFloat(rawNumber);
      if (isNaN(amount)) return 'Invalid numeric value';
    }

    const total = amount * quantity;

    const currency = (window.ShopCurrency || 'USD').toUpperCase();
    const shopLocale = (window.shopLocale || navigator.language || 'en').slice(0, 2);

    const localeMap = {
      af: 'af-ZA', am: 'am-ET', ar: 'ar-SA', az: 'az-AZ', be: 'be-BY', bg: 'bg-BG',
      bn: 'bn-BD', bs: 'bs-BA', ca: 'ca-ES', cs: 'cs-CZ', cy: 'cy-GB', da: 'da-DK',
      de: 'de-DE', el: 'el-GR', en: 'en-US', es: 'es-ES', et: 'et-EE', eu: 'eu-ES',
      fa: 'fa-IR', fi: 'fi-FI', fil: 'fil-PH', fr: 'fr-FR', ga: 'ga-IE', gl: 'gl-ES',
      gu: 'gu-IN', he: 'he-IL', hi: 'hi-IN', hr: 'hr-HR', hu: 'hu-HU', hy: 'hy-AM',
      id: 'id-ID', is: 'is-IS', it: 'it-IT', ja: 'ja-JP', jv: 'jv-ID', ka: 'ka-GE',
      kk: 'kk-KZ', km: 'km-KH', kn: 'kn-IN', ko: 'ko-KR', ky: 'ky-KG', lo: 'lo-LA',
      lt: 'lt-LT', lv: 'lv-LV', mk: 'mk-MK', ml: 'ml-IN', mn: 'mn-MN', mr: 'mr-IN',
      ms: 'ms-MY', mt: 'mt-MT', nb: 'nb-NO', ne: 'ne-NP', nl: 'nl-NL', pl: 'pl-PL',
      ps: 'ps-AF', pt: 'pt-PT', ro: 'ro-RO', ru: 'ru-RU', si: 'si-LK', sk: 'sk-SK',
      sl: 'sl-SI', sq: 'sq-AL', sr: 'sr-RS', sv: 'sv-SE', sw: 'sw-KE', ta: 'ta-IN',
      te: 'te-IN', th: 'th-TH', tl: 'tl-PH', tr: 'tr-TR', uk: 'uk-UA', ur: 'ur-PK',
      uz: 'uz-UZ', vi: 'vi-VN', zh: 'zh-CN', zu: 'zu-ZA'
    };

    let userLocale = localeMap[shopLocale] || 'en-US';

    if (currency === 'VND') userLocale = 'vi-VN';

    const zeroDecimalCurrencies = ['VND', 'JPY', 'KRW', 'IDR', 'THB'];
    const formattedTotal = new Intl.NumberFormat(userLocale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: zeroDecimalCurrencies.includes(currency) ? 0 : 2,
      maximumFractionDigits: zeroDecimalCurrencies.includes(currency) ? 0 : 2
    }).format(total);

    return formattedTotal;
  }


  window.products = {
    async init() {
      const tasks = [
        this.loadIconCart, 
        // this.closeAllModal, 
        this.loadWishlistFromStorage, 
        this.loadWishlist, 
        this.updateWishlistCount,         
        this.loadCompared, 
        this.clearWishlist, 
        this.changeColor, 
        this.shoppingcart,
        this.checkPageDetails
      ];

      const promises = tasks.map(task => {
        if (typeof task === "function") {
          return task();
        }
        return task; 
      });

      try {
        await Promise.all(promises); 
      } catch (error) {
        console.error('Error:', error);
      }
    },
    checkPageDetails() {
      if($('.p-productDetails').length>0) {
        $('.tf-sidebar-compare').parent().hide();
      }
    },
    loadIconCart() {
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        $('.nav-cart .icon-cart').next().remove();
        $('.nav-cart .icon-cart').after('<span class="count-box text-button-small">'+cart.item_count+'</span>');
      });
    },
    shoppingcart() {
      
      
      function like() {
        // Gọi API lấy top view
        fetch(`${linkApp}/product-top-view?domain_name=${domain}&limit=4`)
          .then(res => res.json())
          .then(response => {
            if (response.status === 'success') {
              const data = response.data;
              $('#shoppingCart .list-cart').empty();

              let loadedCount = 0; // đếm số request đã xử lý (thành công hoặc fail)

              $.each(data, function(index, item) {
                if (index >= 5) return false;
                const handle = item.handle;
                const url = `/products/${handle}?view=views`;

                $.ajax({
                  url: url,
                  type: 'GET',
                  success: function(productData) {
                    const doc = new DOMParser().parseFromString(productData, 'text/html');
                    const itemHtml = doc.querySelector('.list-cart-item');

                    if (itemHtml) {
                      $('#shoppingCart .list-cart').append(itemHtml.outerHTML);
                      addCart();
                    }
                  },
                  error: function() {
                    console.warn("Không tìm thấy hoặc lỗi khi load:", handle);
                  },
                  complete: function() {
                    // luôn tăng số đếm kể cả khi lỗi
                    loadedCount++;
                    if (loadedCount === data.length) {
                      $('.wrap-recommendations .loading').hide();
                      subTotal(); // tính lại tổng
                    }
                  }
                });
              });
            } else {
              console.error('API trả về lỗi:', response);
              $('.wrap-recommendations .loading').hide();
            }
          })
          .catch(err => {
            console.error("Error calling recent views API:", err);
            $('.wrap-recommendations .loading').hide();
          });
      }


      function addCart() {
        $('#shoppingCart .btn-add-cart').each(function() {
          $(this).off('click').on('click', function() {
            var variantId = $(this).parents('.list-cart-item').data('variantid');

            if (!variantId) {
              alert('Vui lòng chọn đầy đủ Màu và Size hợp lệ.');
              return;
            }

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                id: variantId,
                quantity: 1
              },
              dataType: 'json',
              success: function (data) {
                products.loadIconCart(); 
                listOrder();                  
                $('.open-cart').trigger('click'); 
                $('.tf-minicart-recommendations').addClass('open');                     
              },
              error: function (err) {
                alert('Không thể thêm vào giỏ hàng. Có thể đã hết hàng.');
                console.error(err);
              }
            });
          })
        })
      }

      function cancel() {
        $('.tf-mini-cart-tool-close').each(function () {
          $(this).closest('.tf-mini-cart-tool-openable').find('input[type=text], textarea').val('');
        })
      }
      cancel();

      function checkout(e) {
        $('#note-hidden').val($('#Cart-note').val());
        $('#shipping-country-hidden').val($('#shipping-country-form').val());
        $('#shipping-province-hidden').val($('#shipping-province-form').val());
        $('#shipping-zip-hidden').val($('#zipcode').val());

        const coupon = $('input[name="discount"]').val();
        if (coupon) {
          e.preventDefault(); 
          window.location.href = `/discount/${coupon}?redirect=/checkout`;
        }
      }
      // checkout();

      function remove() {
        $('.tf-mini-cart-info .remove').each(function () {
          $(this).on('click', function(){
            $(this).closest('.tf-mini-cart-item').addClass('delete');
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: $(this).data('id'), 
                quantity: 0  
              })
            })
            .then(res => res.json())
            .then(cart => {
              $('.notification-add-cart').hide();             
              listOrder(); 
              $(this).closest('.tf-mini-cart-item').removeClass('delete');            
            });
          })
        })
      }

      function progressBar() {
        fetch(`${linkApp}/freeship?domain_name=${domain}&country_code=${Shopify.country}`)
          .then(res => res.json())
          .then(response => {
            if (response.status === 'success') {
                const item = response.data?.[0];
                if (!item) {
              console.warn("Không có item trong response.data");
              $('.txt_codeItem').empty().append(0);
              return;
            }

            let minumum;
            minumum = item.minimum_subtotal;
            // if (item.minimum_requirement == null && item.minimum_quantity == null) {
            //   minumum = item.minimum_subtotal;
            // } else if (typeof item.minimum_requirement === 'string') {
            //   const requirement = item.minimum_requirement.toLowerCase();

            //   if (requirement.includes("vnd")) {
            //     minumum = item.minimum_requirement;
            //   } else if (requirement.includes("sản phẩm")) {
            //     minumum = item.minimum_subtotal;
            //   }
            // }
            let codesArray = [];
            if (Array.isArray(item.codes)) {
              codesArray = item.codes; // Nếu item.codes là mảng, chỉ cần gán trực tiếp
            } else if (typeof item.codes === 'string') {
              try {
                codesArray = JSON.parse(item.codes || '[]');
              } catch (err) {
                console.error("Lỗi khi parse item.codes:", err);
              }
            } else {
              console.error("item.codes không phải là mảng hoặc chuỗi hợp lệ.");
            }

            const renderedCodes = codesArray.join(', ');
            // $('.txt_code').empty().append(renderedCodes);

            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                let progress = 100;
                const _r = subtractPrices(minumum, cart.total_price / 100);
                const prog = subtractPricesValue(minumum, cart.total_price / 100); 
                          
                if (prog <= 0) {
                  progress = 100;
                  $('.tf-mini-cart-threshold .text-caption-1').hide();
                  $('.tf-mini-cart-threshold .text-caption-success').show();
                } else {
                  // progress = 100 - _r;
                  progress = 100 - (prog / minumum * 100);
                  $('.txt_codeItem').empty().append(_r);
                  $('.tf-mini-cart-threshold .text-caption-1').show();
                  $('.tf-mini-cart-threshold .text-caption-success').hide();
                }
                console.log(progress);
                $(".progress-cart .value").css("width", progress + "%");
                // if (typeof item.minimum_requirement === 'string' && item.minimum_quantity != null) {
                //   const requirement = item.minimum_requirement.toLowerCase();

                //   if (requirement.includes("vnd")) {
                //     // const _r = subtractPrices(minumum, cart.total_price / 100);
                //     const _r = subtractPrices(minumum, cart.total_price / 100);
                //     $('.txt_codeItem').empty().append(_r);
                //     if (_r >= 0) {
                //       progress = 100
                //     } else {
                //       progress = _r/minumum*100;
                //     }
                //     console.log('progress',progress);
                //   } else if (requirement.includes("sản phẩm")) {
                //   const itemsRemaining = minumum - cart.item_count;
                //   if (itemsRemaining <= 0) {
                //     $('.txt_codeItem').empty().append('0 items');
                //   } else {
                //     $('.txt_codeItem').empty().append(`${itemsRemaining} items`);
                //   }
                //   progress = (cart.item_count * 100) / minumum;
                // }
                // } else {
                //   $('.txt_codeItem').empty().append(0);
                // }

              // Hiển thị progress bar
              // setTimeout(() => {
              //   $(".tf-progress-bar .value").css("width", progress + "%");
              // }, 1000);
            
              

              // Cập nhật số lượng item trong icon cart
              // $('.nav-cart .icon-cart').next().remove();
              // $('.nav-cart .icon-cart').after(
              //   `<span class="count-box text-button-small">${cart.item_count}</span>`
              // );
            });
            } else {
              console.error('API trả về lỗi:', response);
              $('.tf-mini-cart-threshold .loading').hide();
            }
          })
          .catch(err => console.error("Error calling freeship API:", err));
          $('.tf-mini-cart-threshold .loading').hide();
      }

      function parsePrice(priceStr) {
        let amount = 0;
        let prefix = '';
        let suffix = '';

        if (typeof priceStr === 'number') {
          amount = priceStr;
        } else {
          const regex = /^([^\d\s.,]*)\s*([\d.,]+)\s*([^\d\s.,]*)$/;
          const match = String(priceStr).trim().match(regex);
          if (!match) return null;

          prefix = match[1];
          let rawNumber = match[2];
          suffix = match[3];

          const currency = (window.ShopCurrency || 'USD').toUpperCase();
          const zeroDecimalCurrencies = ['VND', 'JPY', 'KRW', 'IDR', 'THB'];

          if (zeroDecimalCurrencies.includes(currency)) {
            rawNumber = rawNumber.replace(/\./g, '').replace(/,/g, '');
          } else {
            const hasComma = rawNumber.includes(',');
            const hasDot = rawNumber.includes('.');

            if (hasComma && hasDot) {
              if (rawNumber.lastIndexOf(',') > rawNumber.lastIndexOf('.')) {
                rawNumber = rawNumber.replace(/\./g, '').replace(',', '.');
              } else {
                rawNumber = rawNumber.replace(/,/g, '');
              }
            } else if (hasComma && !hasDot) {
              rawNumber = rawNumber.replace(',', '.');
            } else {
              rawNumber = rawNumber.replace(/,/g, '');
            }
          }

          amount = parseFloat(rawNumber);
          if (isNaN(amount)) return null;
        }

        return { value: amount, prefix, suffix };
      }

      function subtractPrices(price1, price2) {
        const parsed1 = parsePrice(price1);
        const parsed2 = parsePrice(price2);

        if (!parsed1 || !parsed2) return 'Invalid price format';

        const rate = window.ShopCurrencyRate || 1;

        let result = (parsed1.value - parsed2.value) * rate;
        if (result <= 0) result = 0;

        const currency = (window.ShopCurrency || 'USD').toUpperCase();
        const shopLocale = (window.shopLocale || navigator.language || 'en').slice(0, 2);

        const localeMap = {
          af: 'af-ZA', am: 'am-ET', ar: 'ar-SA', az: 'az-AZ', be: 'be-BY', bg: 'bg-BG',
          bn: 'bn-BD', bs: 'bs-BA', ca: 'ca-ES', cs: 'cs-CZ', cy: 'cy-GB', da: 'da-DK',
          de: 'de-DE', el: 'el-GR', en: 'en-US', es: 'es-ES', et: 'et-EE', eu: 'eu-ES',
          fa: 'fa-IR', fi: 'fi-FI', fil: 'fil-PH', fr: 'fr-FR', ga: 'ga-IE', gl: 'gl-ES',
          gu: 'gu-IN', he: 'he-IL', hi: 'hi-IN', hr: 'hr-HR', hu: 'hu-HU', hy: 'hy-AM',
          id: 'id-ID', is: 'is-IS', it: 'it-IT', ja: 'ja-JP', jv: 'jv-ID', ka: 'ka-GE',
          kk: 'kk-KZ', km: 'km-KH', kn: 'kn-IN', ko: 'ko-KR', ky: 'ky-KG', lo: 'lo-LA',
          lt: 'lt-LT', lv: 'lv-LV', mk: 'mk-MK', ml: 'ml-IN', mn: 'mn-MN', mr: 'mr-IN',
          ms: 'ms-MY', mt: 'mt-MT', nb: 'nb-NO', ne: 'ne-NP', nl: 'nl-NL', pl: 'pl-PL',
          ps: 'ps-AF', pt: 'pt-PT', ro: 'ro-RO', ru: 'ru-RU', si: 'si-LK', sk: 'sk-SK',
          sl: 'sl-SI', sq: 'sq-AL', sr: 'sr-RS', sv: 'sv-SE', sw: 'sw-KE', ta: 'ta-IN',
          te: 'te-IN', th: 'th-TH', tl: 'tl-PH', tr: 'tr-TR', uk: 'uk-UA', ur: 'ur-PK',
          uz: 'uz-UZ', vi: 'vi-VN', zh: 'zh-CN', zu: 'zu-ZA'
        };

        let userLocale = localeMap[shopLocale] || 'en-US';
        if (currency === 'VND') userLocale = 'vi-VN';

        const zeroDecimalCurrencies = ['VND', 'JPY', 'KRW', 'IDR', 'THB'];
        const formatted = new Intl.NumberFormat(userLocale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: zeroDecimalCurrencies.includes(currency) ? 0 : 2,
          maximumFractionDigits: zeroDecimalCurrencies.includes(currency) ? 0 : 2
        }).format(result);

        return formatted;
      }

      function subtractPricesValue(price1, price2) {
        const parsed1 = parsePrice(price1);
        const parsed2 = parsePrice(price2);

        if (!parsed1 || !parsed2) return NaN;

        const rate = window.ShopCurrencyRate || 1;

        let result = (parsed1.value - parsed2.value) * rate;
        if (result <= 0) result = 0;

        return result;
      }

      function quality() {
        $('.tf-mini-cart-info .wg-quantity').each(function () {
          const $quantityWrapper = $(this);

          if ($quantityWrapper.length === 0) return;

          const $input = $quantityWrapper.find('.quantity-product');
          const $btnDecrease = $quantityWrapper.find('.btn-decrease');
          const $btnIncrease = $quantityWrapper.find('.btn-increase');

          // $btnDecrease.on('click', function () {
          //   $(this).closest('.tf-mini-cart-item').addClass('delete');
          //   let current = parseInt($input.val()) || 1;
          //   if (current > 1) {
          //     $input.val(current - 1);
          //   }
          //   // subTotal();
          //   reCallTotal($(this));
          //   $(this).closest('.tf-mini-cart-item').removeClass('delete');
          //   progressBar();
          // });

          // $btnIncrease.on('click', function () {
          //   $(this).closest('.tf-mini-cart-item').addClass('delete');
          //   let current = parseInt($input.val()) || 1;
          //   $input.val(current + 1);
          //   // subTotal();
          //   reCallTotal($(this));
          //   $(this).closest('.tf-mini-cart-item').removeClass('delete');
          //   progressBar();

          // });

          let debounceTimer; // Biến dùng chung để tránh xử lý trùng

          $btnIncrease.on('click', function () {
            clearTimeout(debounceTimer);
            const $btn = $(this);

            const $item = $btn.closest('.tf-mini-cart-item');
            const $input = $item.find('input'); 

           

            let current = parseInt($input.val()) || 1;
            // $input.val(current + 1);
            const max = parseInt($input.attr('max')); 
            if (current < max) {
              current = current + 1;
            } else {
              current = max; 
              alert("Max " + max + " item")
            }
            $input.val(current);

            debounceTimer = setTimeout(() => {
              $item.addClass('delete');             
              reCallTotal($btn);
              progressBar();
              // $item.removeClass('delete');
            }, 300); 
            
          });

          $btnDecrease.on('click', function () {
            clearTimeout(debounceTimer);
            const $btn = $(this);

            const $item = $btn.closest('.tf-mini-cart-item');
            const $input = $item.find('input');


            let current = parseInt($input.val()) || 1;
            if (current > 1) {
              $input.val(current - 1);
            }

            debounceTimer = setTimeout(() => {
              $item.addClass('delete');

              reCallTotal($btn);
              progressBar();

              // $item.removeClass('delete');
            }, 300);
          });

          // $input.on('input', function () {
          //   let value = parseInt($(this).val());
          //   if (isNaN(value) || value < 1) {
          //     $(this).val(1);
          //   }
          //   // subTotal();
          //   reCallTotal($(this));
          //   $(this).closest('.tf-mini-cart-item').removeClass('delete');
          //   progressBar();

          // });
        })
      }

      function reCallTotal(_this) {
        var _p = _this.parents('.tf-mini-cart-item');
        _p.find('.remove + div').empty().append(_p.find('.quantity-product').val() + ' X ' + multiplyPriceWithQuantity(_p.find('.tf-mini-cart-image').data('price'), 1));
        var _k = _p.attr('data-key');
        var _id = _p.data('id');
        var _qty = _p.find('.quantity-product').val(); 
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: _k,
            quantity: _qty
          }),
        })
          .then(res => res.json())
          .then(data => {
            const item = data.items.find(i => i.id === _id);
            if (item) {
              _p.attr('data-key', item.key); 
            } 

            // products.loadIconCart();
            listOrder();
            // Update UI
          });
      }

      function listOrder() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          $('.nav-cart .icon-cart').next().remove();
          $('.nav-cart .icon-cart').after('<span class="count-box text-button-small">'+cart.item_count+'</span>');

          $('.tf-mini-cart-items').empty();
          $('.tf-totals-total-value').empty().append(multiplyPriceWithQuantity(cart.total_price/100,1));

          if (!cart.items || cart.items.length === 0) {
            $('.tf-mini-cart-content').addClass('empty');
            $('.tf-mini-cart-empty').show();
            $('.tf-minicart-body').css('display','none');
          } else {
             $('.tf-mini-cart-empty').hide();
              $('.tf-minicart-body').css('display','flex');
              $('.tf-mini-cart-content').removeClass('empty');
          cart.items.forEach(item => {              
              if (!item) return;

              let maxQty = window.MINI_CART_MAX[item.key] || 9999;

              let imageHtml = '';
              if (item.image) {
                imageHtml = `
                  <div class="tf-mini-cart-image" data-price="${item.price / 100}" data-sum="${item.line_price / 100}" data-handle="${item.handle}">
                    <img class="lazyloaded" data-src="${item.image}" src="${item.image}" alt="${item.title}">
                  </div>
                `;
              }

              let variantHtml = '';
              if (item.variant_title) {
                variantHtml = `<div class="text-secondary-2">${item.variant_title}</div>`;
              }
              const currencySymbol = document.querySelector('.tf-mini-cart-items').dataset.symbol;
              var CurrencySymboy = window.CurrencySymboy;
              $('.tf-mini-cart-items').append(`
                <div class="tf-mini-cart-item file-delete" data-id="${item.id}" data-key="${item.key}">
                  ${imageHtml}
                  <div class="tf-mini-cart-info flex-grow-1">
                    <div class="content">
                      <div class="left">
                        <div class="text-title">
                          <a href="${item.url || '#'}" class="link line-clamp-1">${item.product_title || 'Không có tên'}</a>
                        </div>
                        ${variantHtml}
                        <div class="wg-quantity">
                          <span class="btn-quantity btn-decrease">-</span>
                          <input type="text" class="quantity-product" name="number" value="${item.quantity}" max="${maxQty}">
                          <span class="btn-quantity btn-increase">+</span>
                        </div>
                      </div>
                      <div class="right">
                        <div class="text-button tf-btn-remove remove" data-id="${item.key}">Remove</div>
                        <div class="text-button">
                          ${item.quantity} X ${multiplyPriceWithQuantity(item.presentment_price,1)} 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              `);
            });

          }

          
          
          $('.tf-mini-cart-wrap .loading').hide();

          $('.notification-add-cart').addClass('show');
          setTimeout(function() {
            $('.notification-add-cart').removeClass('show');
          }, 1500); 

          const note = cart.note;
          $('#Cart-note').val(note);

          quality();
          remove();
          
        });
        progressBar();
      }
      
      function subTotal() {
        let sumSub = 0;
        $('.tf-mini-cart-item').each(function () {
          const price = $(this).find('.tf-mini-cart-image').data('price');
          const qty = $(this).find('.quantity-product').val();
          sumSub += price * qty;
        });

        $('.tf-totals-total-value').empty().text(sumSub.toLocaleString());
      }


      function updateSubtotal() {
        var price = "0", compare = "0";
        $('{{ class }} .buy-it-with .product-item.added .lstPriceRelated .item.active .old-price').each(function () {
          price = sumFormattedPrices(price, $(this).data('price'));
        });

        $('.tf-totals-total-value').empty().append(price);
      }

      function sumFormattedPrices(priceStr1, priceStr2) {
        const regex = /^([^\d\s.,]*)\s*([\d.,]+)\s*([^\d\s.,]*)$/;

        const parsePrice = (str) => {
          const match = String(str).trim().match(regex);
          if (!match) return { amount: 0, prefix: '', suffix: '' };

          const prefix = match[1];
          const rawNumber = match[2];
          const suffix = match[3];

          const normalized = rawNumber.replace(/\./g, '').replace(',', '.');
          const amount = parseFloat(normalized);

          return {
            amount: isNaN(amount) ? 0 : amount,
            prefix,
            suffix
          };
        };

        const p1 = parsePrice(priceStr1);
        const p2 = parsePrice(priceStr2);

        const total = p1.amount + p2.amount;

        const formatted = total.toLocaleString('vi-VN');

        const prefix = p1.prefix || p2.prefix || '';
        const suffix = p1.suffix || p2.suffix || '';

        return `${prefix}${formatted}${suffix}`.trim();
      }

      function calculateDiscountPercent(priceStr, compareStr) {
        const regex = /^([^\d\s.,]*)\s*([\d.,]+)\s*([^\d\s.,]*)$/;

        const parseAmount = (str) => {
          const match = str.trim().match(regex);
          if (!match) return 0;

          const rawNumber = match[2]; 
          const normalized = rawNumber.replace(/\./g, '').replace(',', '.');
          const amount = parseFloat(normalized);

          return isNaN(amount) ? 0 : amount;
        };

        const price = parseAmount(priceStr);
        const compare = parseAmount(compareStr);

        if (compare <= 0 || price <= 0 || price >= compare) return "";

        const discount = ((compare - price) / compare) * 100;
        const rounded = Math.round(discount); 

        return `-${rounded}%`;
      }

      

      // $(".modal-shopping-cart").on("hide.bs.modal", function () {
      //   $(".tf-progress-bar .value").css("width", "0%");
      //   $('.modal-shopping-cart .loading').show();
      //   $('#shoppingCart .list-cart, .tf-mini-cart-items').empty();
      //   // $('#shoppingCart .tf-progress-bar, #shoppingCart .tf-progress-bar + div').hide();
      // });

      $('.open-cart').off('click').on('click', function (e) {
        e.preventDefault();

        // let currentModal = bootstrap.Modal.getInstance(document.querySelector('.modal.show'));
        // if (currentModal) currentModal.hide();

        const cartModal = new bootstrap.Modal(document.getElementById('shoppingCart'));
        cartModal.show();

        runTask([like, progressBar, listOrder,loadCoupon]);
        // runTask([like, listOrder]);
      });

      function loadCoupon() {
        const storageKey = "tf_discount";
        const savedCode = localStorage.getItem(storageKey);
        if (savedCode) {
          $('input[name="discount"]').val(savedCode);
        }
      }
    },
    closeAllModal() {
      $('.modal').on('click', function(e) {
        if (!$(e.target).closest('.modal-content').length) {
          clearInterval(viewingInterval);
          viewingInterval = null;
          $(this)
            .fadeOut() 
            .removeClass('show')
            .attr('aria-hidden', 'true')
            .removeAttr('aria-modal'); 
          if($('.p-carts').length)
            window.location.reload();
        }
      });
    },

    generateRandomString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters[Math.floor(Math.random() * characters.length)];
      }
      return result;
    },

    activeElement(_this){
      _this.addClass('active').siblings().removeClass('active');
    },

    loadWishlistFromStorage() {
      const dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');
      const dataCompare = dataUser.dataCompare || [];
      $('.tf-sidebar-compare .content').empty();
      dataCompare.forEach(item => {
        $('.tf-sidebar-compare .content').append(`
          <div class="item" data-id="${item.id}">
            <span class="remove">
              <span class="icon icon-close"></span>
            </span>
            <a href="${item.url}" title=""><img src="${item.img}" alt=""></a>
          </div>`);
      });

      // if (dataCompare.length > 0) $('.tf-sidebar-compare').addClass('active');
    },

    loadWishlist() {
      const dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');
      if (Array.isArray(dataUser.dataWishlist)) {
        $('.card-product').each(function() {
          if (dataUser.dataWishlist.some(item => item.id == $(this).data('productid'))) {
            $(this).addClass('wishlisted');
            $(this).find('.box-icon.wishlist .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
            var tooltipDelete = $(this).find('.box-icon.wishlist').data('tooltip-delete');
            $(this).find('.box-icon.wishlist .tooltip').text(tooltipDelete);
          }
        });
      } 
    },
    updateWishlistCount() {
      const count = getWishlistCount();
      $('.wishlist-count').text(count);
    },

    loadCompared() {
      const dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');
      if (Array.isArray(dataUser.dataCompare)) {
        $('.card-product').each(function() {
          if (dataUser.dataCompare.some(item => item.id == $(this).data('productid'))) {
            $(this).addClass('compared');
            $(this).find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>'); 
            var tooltipDelete = $(this).find('.box-icon.compare').data('tooltip-delete');
            $(this).find('.box-icon.compare .tooltip').text(tooltipDelete);           
          }
        });
      }
    },

    clearWishlist() {
      $('.clear-wishlist').off('click').on('click', function(e) {
        e.preventDefault();

        const dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');
        dataUser.dataWishlist = [];
        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        let count_wl = dataUser.dataWishlist ? dataUser.dataWishlist.length : 0;
        $('.wishlist-count').text(count_wl);

        $('.card-product').removeClass('wishlisted');
        alert('Wishlist đã được xoá sạch!');
      });
    },

    changeColor() {
      $('.card-product .colorItem').unbind('click').bind('click', function() {
        var _i = $(this).data('index');
        var _this = $(this).parents('.card-product');
        products.activeElement($(this)); 
        products.activeElement(_this.find('.img' + _i));  
        products.activeElement(_this.find('.price' + _i)); 
        products.activeElement(_this.find('.sales' + _i)); 

        const $card = $(this).closest('.card-product');
        const productId = $(this).data('id'); 
        const dataUser = JSON.parse(localStorage.getItem('dataUser') || '{}');

        if (Array.isArray(dataUser.dataWishlist)) {
          const inWishlist = dataUser.dataWishlist.some(item => item.id == productId);
          if (inWishlist) {
            $card.addClass('wishlisted');
            $card.find('.box-icon.wishlist .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
            var tooltipDelete = $card.find('.box-icon.wishlist').data('tooltip-delete');
            $card.find('.box-icon.wishlist .tooltip').text(tooltipDelete);
          } else {
            $card.removeClass('wishlisted');
            $card.find('.box-icon.wishlist .icon_wrap').html('<span class="icon icon-heart"></span>');
            var tooltipDelete = $card.find('.box-icon.wishlist').data('tooltip');
            $card.find('.box-icon.wishlist .tooltip').text(tooltipDelete);
          }
        }

        if (Array.isArray(dataUser.dataCompare)) {
          const inCompare = dataUser.dataCompare.some(item => item.id == productId);
          if (inCompare) {
            $card.addClass('compared');
            $card.find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');  
            var tooltipDelete = $card.find('.box-icon.compare').data('tooltip-delete');
            $card.find('.box-icon.compare .tooltip').text(tooltipDelete); 
          } else {
            $card.removeClass('compared');
            $card.find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
            var tooltipDelete = $card.find('.box-icon.compare').data('tooltip');
            $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          }
        }
      });
      $('.card-product .colorItem:first').trigger('click');
    }
  };

  window.S00801SidebarCompare = {
    init() {
      this.close();
      this.remove();
      this.clearAll();
    },

    close() {
      $('.tf-sidebar-compare .close,.tf-sidebar-compare .overlay').off('click').on('click', function() {
        $('.tf-sidebar-compare.active').removeClass('active');;
      });
    },

    remove() {
      $('.tf-sidebar-compare').on('click', '.remove', function(e) {
        e.preventDefault();

        const $item = $(this).closest('.item');
        const productId = $item.data('id');
        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (Array.isArray(dataUser.dataCompare)) {
          dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
          localStorage.setItem("dataUser", JSON.stringify(dataUser));
        }

        $item.remove();
        if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;

        $('.card-product').each(function() {
          if ($(this).data('productid') == productId) {
            $(this).removeClass('compared');
            $(this).find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
            var tooltipDelete = $(this).find('.box-icon.compare').data('tooltip');
            $(this).find('.box-icon.compare .tooltip').text(tooltipDelete);
            return false;
          }
        });
      });
    },

    clearAll() {
      $('.tf-sidebar-compare .clear').off('click').on('click', function(e) {
        e.preventDefault();

        localStorage.setItem("dataUser", JSON.stringify({
          ...JSON.parse(localStorage.getItem("dataUser") || '{}'),
          dataCompare: []
        }));
        $('.card-product.compared').removeClass('compared');
        $('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
        var tooltipDelete = $('.box-icon.compare').data('tooltip');
        $('.box-icon.compare .tooltip').text(tooltipDelete);
        const $sidebar = $(this).parents('.tf-sidebar-compare');
        $sidebar.find('.content').empty();
        $sidebar.removeClass('active');
      });
    }
  };

  window.S00601CartProduct = {
    init() {
      this.wishlist();
      this.compare();
      this.quickView();
      this.addToCart();
      this.updateWishlistCount();
    },

    addToCart(){
      $('.card-product .btn-add-cart, .card-product .addcart').unbind('click').bind('click', function (e) {
        e.preventDefault();
        var btn = $(this);
        btn.addClass('btn-cart-loading');
        var variantId = $(this).parents('.card-product').find('.colorItem.active').data('id');
        if(variantId == undefined)
          variantId = $(this).parents('.card-product').data('productid');

        if (!variantId) {
          alert('Vui lòng chọn đầy đủ Màu và Size hợp lệ.');
          return;
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: variantId,
            quantity: 1
          },
          dataType: 'json',
          success: function (data) {
            products.loadIconCart();
            // fetch(`${linkApp}/product-top-view?domain_name=${domain}`) 
            // .then(res => res.json())
            // .then(data1 => {
            //     $('.wrap-recommendations .loading').hide();
            // })
            // .catch(err => console.error("Error calling recent views API:", err)); 
            $('.wrap-recommendations .loading').hide();
            $('.notification-add-cart').show();
            $('.open-cart').trigger('click');    
           
            btn.removeClass('btn-cart-loading');       
          },
          error: function (err) {
            alert('Cannot add to cart. May be out of stock.');
            console.error(err);
          }
        });
        
      })
    },
    updateWishlistCount() {
      const count = getWishlistCount();
      $('.wishlist-count').text(count);
    },

    wishlist() {
      $('.card-product .wishlist').off('click').on('click', function(e) {
        e.preventDefault();

        const $card = $(this).closest('.card-product');
        const productId = $card.find('.colorItem.active').data('id') || $card.data('productid');
        const img = $card.find('.colorItem.active').data('img') || $card.find('.image-wrap img:first').attr('src');
        const url = $card.find('.image-wrap').attr('href') + (productId ? `?variant=${productId}` : '');

        if (!productId) return;

        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (!dataUser.randomId) {
          dataUser = {
            id: typeof customerId !== "undefined" ? customerId : "",
            randomId: themeName + products.generateRandomString(30),
            dataWishlist: [],
            dataCompare: []
          };
        }

        const exists = dataUser.dataWishlist?.some(item => item.id == productId);

        
        if (exists) {
          dataUser.dataWishlist = dataUser.dataWishlist.filter(item => item.id != productId);
          $card.removeClass('wishlisted');
          $card.find('.box-icon.wishlist .icon_wrap').html('<span class="icon icon-heart"></span>');
          var tooltipDelete = $card.find('.box-icon.wishlist').data('tooltip');
          $card.find('.box-icon.wishlist .tooltip').text(tooltipDelete);
        } else {
          dataUser.dataWishlist = [...(dataUser.dataWishlist || []), { id: productId, img, url }];
          $card.addClass('wishlisted');
          $card.find('.box-icon.wishlist .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
          var tooltipDelete = $card.find('.box-icon.wishlist').data('tooltip-delete');
          $card.find('.box-icon.wishlist .tooltip').text(tooltipDelete);
        }

        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        let count_wl = dataUser.dataWishlist ? dataUser.dataWishlist.length : 0;
        $('.wishlist-count').text(count_wl);
        if (window.location.pathname.includes('wishlist')) {
          if (typeof wishlist !== 'undefined' && typeof wishlist.load === 'function') {
            wishlist.load();
          } else {
            $(document).trigger('wishlist:reload');
          }
        }
      });
    },

    compare() {
      $('.card-product .compare').off('click').on('click', function(e) {
        e.preventDefault();
        const modalElement = document.getElementById('search');
        const modalSearch = bootstrap.Modal.getInstance(modalElement);
        if (modalSearch) {
            modalSearch.hide(); 
        }
        const $card = $(this).closest('.card-product');
        const productId = $card.find('.colorItem.active').data('id') || $card.data('productid');
        const img = $card.find('.colorItem.active').data('img') || $card.find('.image-wrap img:first').attr('src');
        const url = $card.find('.image-wrap').attr('href') + (productId ? `?variant=${productId}` : '');

        if (!productId) return;

        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (!dataUser.randomId) {
          dataUser = {
            id: typeof customerId !== "undefined" ? customerId : "",
            randomId: themeName + products.generateRandomString(100),
            dataWishlist: [],
            dataCompare: []
          };
        }

        const exists = dataUser.dataCompare?.some(item => item.id == productId);

        if (exists) {
          dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
          $(`.tf-sidebar-compare .item[data-id="${productId}"]`).remove();
          $card.removeClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);

          if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;
        } else {
          dataUser.dataCompare = [...(dataUser.dataCompare || []), { id: productId, img, url }];
          $('.tf-sidebar-compare .content').append(`
            <div class="item" data-id="${productId}">
              <span class="remove">
                <span class="icon icon-close"></span>
              </span>
              <a href="${url}" title=""><img src="${img}" alt=""></a>
            </div>`);
          $card.addClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip-delete');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          $('.tf-sidebar-compare').addClass('active');
        }

        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        S00801SidebarCompare.init();
      });
    },

    quickView() {
      const modal = document.getElementById('quickView');
      

      $('.card-product .quickview').off('click').on('click', function(e) {
        e.preventDefault();
        const modalElement = document.getElementById('search');
        const modalSearch = bootstrap.Modal.getInstance(modalElement);
        if (modalSearch) {
            modalSearch.hide(); 
        }
        open($(this).data('handle'), $(this).parents('.card-product').data('productid'));
      })

      function renderInnerHTML(_c, $html) {
        var _imgsEl = $html.filter(_c); 
        if (_imgsEl.length === 0) {
          _imgsEl = $html.find(_c); 
        }
        return _imgsEl[0]?.innerHTML;
      }

      function open(handle, pID) {
        $.get('/products/' + handle + '?view=quick-view', function(data) {
          var $html = $(data);
          handleProduct = handle;
          var _imgs = renderInnerHTML('.modal-images', $html);
          var _header = renderInnerHTML('.modal-header', $html);
          var _content = renderInnerHTML('.modal-content', $html);

          $('#quickView .wrap-quick-view').empty().append(_imgs);
          $('#quickView .tf-product-info-heading').empty().append(_header);
          // $('#quickView .tf-product-info-choose-option').empty().append(_content);
          starts(pID);
        }).fail(function(xhr, status, error) {
          console.error("Load failed:", status, error);
        });


       
      }

      // var sColor="";

      // function clickColors() {
      //   $('.modal .colorItem').on('click', function () {
      //     $('#quickView .list_sizes .item').removeClass('active');
      //     var _sC = $(this).data('color');
      //     var _ind = $(this).data('index');
      //     var percent = $(this).data('percent');
      //     var _e;
      //     $('.modal .list_sizes').eq(_ind).addClass('active').siblings().removeClass('active');

      //     if(sColor != _sC) {
      //       _sC = _sC;
      //       _e = $('.modal .list_sizes').eq(_ind).find('.item:first').addClass('active');
      //     }
      //     else {
      //       //get item
      //       _e = $('.modal .list_sizes').eq(_ind).find('.item.active');
      //     }
      //     var pID = $('.modal .list_sizes').eq(_ind).find('.item.active').data('id');
      //     //fill price
      //     $(`.modal .price${_ind}`).empty().attr('data-price', _e.data('price')).append('<span class="old-price">'+_e.data('compare')+'</span>'+_e.data('price'))
      //     //fill percent
      //     $(`.modal .tip_sale.sales${_ind}`).empty().append(percent)
      //     //fill sold
      //     sold_last_32h(pID);
      //     product_viewing(pID);
      //     changeSize();
      //     //fill button
      //     $(`.modal .total-price`).empty().append(_e.data('price'));
      //     $(this).addClass('active').siblings().removeClass('active');
      //   })
      // }

      // function changeSize() {
      //   $('#quickView .list_sizes .item').unbind('click').bind('click', function () {
      //     $(this).addClass('active').siblings().removeClass('active').parents('.list_sizes').addClass('active').siblings().removeClass('active');
      //     var _tColor = $('.modal .colorItem.active');

      //     var _sC = _tColor.data('color');
      //     var _ind = _tColor.data('index');
      //     var pID = _tColor.data('id');
      //     var percent = _tColor.data('percent');
      //     var _e = $(this);
      //     $('#quickView .quantity-product').val(1);
      //     //fill price
      //     $(`.modal .price${_ind}`).empty().append('<span class="old-price">'+_e.data('compare')+'</span>'+_e.data('price'))
      //     //fill percent
      //     $(`.modal .tip_sale.sales${_ind}`).empty().append(percent)
      //     //fill button
      //     $(`.modal .total-price`).empty().append(_e.data('price'));
      //   })
      // }

      // function sold_last_32h(pID) {
      //   fetch(`${linkApp}/sold-32h?product_id=${pID}&domain=${domain}&hours=32`, {
      //     method: 'GET',
      //     headers: { 'Content-Type': 'application/json' }
      //   })
      //   .then(res => res.json())
      //   .then(data => {
      //     if (data.status === 'success') {
      //       if(data.total_sold=="0")
      //         $('#quickView .tf-product-info-sold').remove();
      //       else
      //         $('#quickView .sum_sold').empty().append(data.total_sold);
      //     } else {
      //       console.error('Error:', data.message);
      //     }
      //   })
      //   .catch(err => console.error('Error:', err));
      // }

      // function getDataUser() {
      //   let raw = localStorage.getItem('dataUser');
      //   let dataUser;

      //   try {
      //     dataUser = raw ? JSON.parse(raw) : null;
      //   } catch {
      //     dataUser = null;
      //   }

      //   const isValid = (
      //     dataUser &&
      //     typeof dataUser === 'object' &&
      //     'id' in dataUser &&
      //     'randomId' in dataUser &&
      //     Array.isArray(dataUser.dataWishlist) &&
      //     Array.isArray(dataUser.dataCompare)
      //   );

      //   if (!isValid) {
      //     dataUser = {
      //       id: "",
      //       randomId: themeName + products.generateRandomString(30),
      //       dataWishlist: [],
      //       dataCompare: []
      //     };
      //     localStorage.setItem("dataUser", JSON.stringify(dataUser));
      //     let count_wl = dataUser.dataWishlist ? dataUser.dataWishlist.length : 0;
      //     $('.wishlist-count').text(count_wl);
      //   }

      //   return dataUser;
      // }

      // function startLiveViewing(pID, userId) {
      //   if (viewingInterval !== null) {
      //     clearInterval(viewingInterval);
      //   }

      //   viewingInterval = setInterval(() => {
      //     fetch(`${linkApp}/product-views?product_id=${pID}&user_id=${userId}&domain_name=${domain}&handle=${handleProduct}`)
      //       .then(res => res.json())
      //       .then(data => {
      //         $('.liveview-count').empty().append(data.views);
      //       })
      //       .catch(err => console.error("Error calling product-views API:", err));
      //   }, 120000);
      // }

      // function product_viewing(pID) {
      //   const dataUser = getDataUser();
      //   let userId = dataUser.randomId;

      //   fetch(`${linkApp}/product-views?product_id=${pID}&user_id=${userId}&domain_name=${domain}&handle=${handleProduct}`)
      //     .then(res => res.json())
      //     .then(data => {
      //       $('.liveview-count').empty().append(data.views);
      //     })
      //     .catch(err => console.error("Error calling product-views API:", err));

      //   startLiveViewing(pID, userId);
      //   // Gọi API lấy 10 sản phẩm đã xem gần nhất
      //   // fetch(`${domainAPI}/wp-json/shopify-viewing/v1/recent?user_id=${userId}&domain_name=${shopifyDomain}`)
      //   //     .then(res => res.json())
      //   //     .then(data => {
      //   //         console.log("Recent Viewed Products:", data.data);
      //   //     })
      //   //     .catch(err => console.error("Error calling recent views API:", err));

      //   // Gọi API lấy 5 sản phẩm đã xem nhiều nhất gần nhất
      //   // fetch(`${domainAPI}${linkpreviewing}/product-top-view?domain_name=${domain}`)
      //   // .then(res => res.json())
      //   // .then(data => {
      //   //     console.log("Recent Viewed Products:", data.data);
      //   // })
      //   // .catch(err => console.error("Error calling recent views API:", err));
      // }



      function getReviews(domain, productId, callback) {
        const url = new URL(`${linkApp}/get-reviews`);
        url.searchParams.append('domain', domain);
        url.searchParams.append('product_id', productId);

        fetch(url.toString())
          .then(response => response.json())
          .then(data => {
            if (data.status === 'success') {
              const reviews = data.reviews || [];
              const total = data.total || 0;
              const averageRating = data.average_rating || 0;

              $('.sum_reviews').empty().append(total);
              $('#quickView .star-rating').attr('aria-label', total + " star");
              $('#quickView .stars-inner').css('width', (averageRating * 20) + "%");
              clickColors();
              $('.modal .colorItem:first').trigger('click');
            } else {
              console.error('Error fetching reviews:', data.message);
            }
          })
          .catch(error => {
            console.error('Request failed:', error);
          });
      }

      //load rate stars
      function starts(pID) {
        clearInterval(viewingInterval);
        viewingInterval = null;
        // getReviews(domain, pID);
        eventsProduct.init();
        const modal = new bootstrap.Modal(document.getElementById('quickView'));
        modal.show();
      }

      function close() {
        $('#quickView .icon-close-popup').off('click').on('click', function(e) {
          clearInterval(viewingInterval);
          viewingInterval = null;
          modal.style.display = 'none';
          modal.classList.remove('show');
          modal.setAttribute('aria-hidden', 'true');
          modal.removeAttribute('aria-modal');
          document.body.classList.remove('modal-open');
          $('#quickview-content').empty();
        })
      }
      close();
    }
  };

  window.eventsProduct = {
    init: function () {
      this.compare();
      this.addcart();
      this.buynow();
      this.wishlist();
      this.sizeguide();
      this.handleQuantityChange();
    },
    buynow:function () {
      $('#quickView .show-shopping-cart').on('click', function(e) {
        e.preventDefault();

        const variantId = $('.list_sizes .item.active').data('id');
        const quantity = $('.list_sizes .quantity-product').val();

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: quantity,
            id: variantId
          },
          dataType: 'json',
          success: function() {
            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              $('.nav-cart .icon-cart').next().remove();
              $('.nav-cart .icon-cart').after('<span class="count-box text-button-small">'+cart.item_count+'</span>');
            });
          },
          error: function(err) {
            alert('Add to cart failed.');
            console.error(err);
          }
        });
      });
    },
    addcart:function () {
      $('#quickView .show-shopping-cart').unbind('click').bind('click', function (e) {
        e.preventDefault();
        const variantId = $('.list_sizes .item.active').data('id');
        const quantity = $('.list_sizes .quantity-product').val();

        if (!variantId) {
          alert('Vui lòng chọn đầy đủ Màu và Size hợp lệ.');
          return;
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: variantId,
            quantity: quantity
          },
          dataType: 'json',
          success: function (data) {
            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              $('.nav-cart .icon-cart').next().remove();
              $('.nav-cart .icon-cart').after('<span class="count-box text-button-small">'+cart.item_count+'</span>');
            });
          },
          error: function (err) {
            alert('Không thể thêm vào giỏ hàng. Có thể đã hết hàng.');
            console.error(err);
          }
        });
      })
    },
    sizeguide: function () {
      $('.size-guide').off('click').on('click', function(e) {
        const modal = new bootstrap.Modal(document.getElementById('size-guide'));
        modal.show();
        return false;
      })
    },
    wishlist:function () {
      $('#quickView .wishlist').off('click').on('click', function(e) {
        e.preventDefault();

        const $card = $('#quickView .list_sizes.active').find('.item.active');
        const productId = $card.data('id');
        const img = $card.data('img');
        const url = "/products/" + $card.data('handle') + (productId ? `?variant=${productId}` : '');

        if (!productId) return;

        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (!dataUser.randomId) {
          dataUser = {
            id: typeof customerId !== "undefined" ? customerId : "",
            randomId: themeName + products.generateRandomString(30),
            dataWishlist: [],
            dataCompare: []
          };
        }

        const exists = dataUser.dataWishlist?.some(item => item.id == productId);

        if (exists) {
          dataUser.dataWishlist = dataUser.dataWishlist.filter(item => item.id != productId);
          $card.removeClass('wishlisted');
          $card.find('.box-icon.wishlist .icon_wrap').html('<span class="icon icon-heart"></span>');
          var tooltipDelete = $card.find('.box-icon.wishlist').data('tooltip');
          $card.find('.box-icon.wishlist .tooltip').text(tooltipDelete);
        } else {
          dataUser.dataWishlist = [...(dataUser.dataWishlist || []), { id: productId, img, url }];
          $card.addClass('wishlisted');
          $card.find('.box-icon.wishlist .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
          var tooltipDelete = $card.find('.box-icon.wishlist').data('tooltip-delete');
          $card.find('.box-icon.wishlist .tooltip').text(tooltipDelete);
        }

        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        let count_wl = dataUser.dataWishlist ? dataUser.dataWishlist.length : 0;
        $('.wishlist-count').text(count_wl);
      });
    },
    compare : function () {
      $('#quickView .compare').off('click').on('click', function(e) {
        e.preventDefault();

        const $card = $('#quickView .list_sizes.active').find('.item.active');
        const productId = $card.data('id');
        const img = $card.data('img');
        const url = "/products/" + $card.data('handle') + (productId ? `?variant=${productId}` : '');

        if (!productId) return;

        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (!dataUser.randomId) {
          dataUser = {
            id: typeof customerId !== "undefined" ? customerId : "",
            randomId: themeName + products.generateRandomString(100),
            dataWishlist: [],
            dataCompare: []
          };
        }

        const exists = dataUser.dataCompare?.some(item => item.id == productId);

        if (exists) {
          dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
          $(`.tf-sidebar-compare .item[data-id="${productId}"]`).remove();
          $card.removeClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;
        } else {
          dataUser.dataCompare = [...(dataUser.dataCompare || []), { id: productId, img, url }];
          $('.tf-sidebar-compare .content').append(`
            <div class="item" data-id="${productId}">
              <span class="remove">
                <span class="icon icon-close"></span>
              </span>
              <a href="${url}" title=""><img src="${img}" alt=""></a>
            </div>`);
          $card.addClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip-delete');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          $('.tf-sidebar-compare').addClass('active');;
        }

        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        S00801SidebarCompare.init();
      });
    },

    handleQuantityChange: function () {
      $(document).ready(function () {
        const $quantityWrapper = $('.wg-quantity');

        if ($quantityWrapper.length === 0) return;

        const $input = $quantityWrapper.find('.quantity-product');
        const $btnDecrease = $quantityWrapper.find('.btn-decrease');
        const $btnIncrease = $quantityWrapper.find('.btn-increase');

        $btnDecrease.on('click', function () {
          let current = parseInt($input.val()) || 1;
          if (current > 1) {
            $input.val(current - 1);
          }
          $('#quickView .total-price').empty().append(multiplyPriceWithQuantity( $('.list_sizes.active .item.active').data('price'), $input.val()))
        });

        $btnIncrease.on('click', function () {
          let current = parseInt($input.val()) || 1;
          const max = parseInt($input.attr('max')); 
          if (current < max) {
            current = current + 1;
          } else {
            current = max; 
            alert("Max " + max + " item")
          }
          $input.val(current);
          // $input.val(current + 1);
          
          $('#quickView .total-price').empty().append(multiplyPriceWithQuantity( $('.list_sizes.active .item.active').data('price'), $input.val()))
        });

        $input.on('input', function () {
          let value = parseInt($(this).val());
          if (isNaN(value) || value < 1) {
            $(this).val(1);
          }
        });
      });
    }
  };

  window.productDetail = {
    init :function () {
      this.zoomImg();
    },
    zoomImg: function () {
      $( document ).ready(function() {
        var image = $('#main-image')[0];
        if ($(image).length) 
        {
          $(image).xzoom({
              tint: '#333',
              Xoffset: 100,
              tintOpacity: 0.05,
              defaultScale: -1,
              zoomWidth: 250,
              zoomHeight: 250
          });
        }
      })
    }
  }

  products.init();
  S00801SidebarCompare.init();
  S00601CartProduct.init();
  eventsProduct.init();
  productDetail.init();

  var clickModalSecond = function () {        
        $(".btn-add-note").on("click",function () {
            $(".add-note").addClass("open");
        });
        $(".btn-add-coupon").on("click",function () {
            $(".add-coupon").addClass("open");
        });
        $(".btn-estimate-shipping").on("click",function () {
            $(".estimate-shipping").addClass("open");
        });
        $(".tf-mini-cart-tool-close").on("click",function () {
            $(".tf-mini-cart-tool-openable").removeClass("open");
        });
  };
  clickModalSecond();

  function addCartNote() {    

    $('.form-add-note').on('submit', function(e) {
      e.preventDefault();
      var note = $('#Cart-note').val();

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { note: note },
        dataType: 'json',
        success: function(cart) {
          alert('Note saved!');
        },
        error: function(err) {
          alert('There was an error saving your note.');
          console.error(err);
        }
      });
      
    });    
    
  }

  
  function saveCoupon() {
    
    const storageKey = "tf_discount";

    function setCoupon(code) {
      //check api first
      fetch(`${linkApp}/check-coupon?domain_name=${domain}&code=${code}`)
      .then(res => res.json())
      .then(response => {
        if (response.data === true ) {
          localStorage.setItem(storageKey, code);
          $('input[name="discount"]').val(code);
          alert("Discount code saved ✅");
          $(".tf-mini-cart-tool-close").trigger('click');
        } else {
          alert("Discount code error");
          console.error('API return error:', response);
        }
      })
      .catch(err => {
        console.error("Error calling recent views API:", err);
      });
    }

    function getCoupon() {
      return localStorage.getItem(storageKey) || "";
    }

    const saved = getCoupon();
    if (saved) {
      // $('input[name="discount"]').val(saved);
    }

    $(document).on("submit", ".form-add-coupon, .ip-discount-code form", function(e) {
      e.preventDefault();
      const $input = $(this).find("input[name='discount']");
      const code = $input.val().trim();
      if (!code) {
        alert("Please enter a discount code");
        return;
      }

      setCoupon(code);
    });

  }

  function getWishlistCount() {
    const dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');
    return dataUser.dataWishlist ? dataUser.dataWishlist.length : 0;
  }

  function updateWishlistCount() {
    const count = getWishlistCount();
    $('.wishlist-count').text(count);
  }


  $(document).ready(function() {
    addCartNote();
    saveCoupon();
  });
});
